import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { CartComponentBase } from '@shared';
import defaultImage from '@/assets/default-food-image.svg';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Cart',
    setup(__props) {
        const theme = {
            primary: 'red',
            secondary: 'gray'
        };
        const translations = {
            title: 'Warenkorb',
            emptyTitle: 'Ihr Warenkorb ist leer',
            emptyMessage: 'Fügen Sie köstliche Gerichte aus unserer Speisekarte hinzu!',
            toMenuButton: 'Zur Speisekarte',
            total: 'Gesamt',
            checkoutButton: 'Zur Kasse'
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(CartComponentBase), {
                theme: theme,
                translations: translations,
                "menu-route": "/speisekarte",
                "checkout-route": "/checkout",
                "default-image": _unref(defaultImage)
            }, null, 8 /* PROPS */, ["default-image"]));
        };
    }
});
